import { useRef, useState } from "react";
import { ArrowRight } from "lucide-react";

export const PrimaryButton = ({ children, onClick, testid, className = "", small = false, type = "button", disabled = false, ariaLabel }) => {
  const ref = useRef(null);
  const [off, setOff] = useState({ x: 0, y: 0 });
  const onMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (r) setOff({ x: 8 * ((e.clientX - r.left) / r.width - 0.5), y: 6 * ((e.clientY - r.top) / r.height - 0.5) });
  };
  return (
    <button
      ref={ref}
      type={type}
      data-testid={testid}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      onMouseMove={onMove}
      onMouseLeave={() => setOff({ x: 0, y: 0 })}
      style={{ transform: `translate(${off.x}px, ${off.y}px)` }}
      className={`btn-sun group ${small ? "px-5 py-2.5 text-[11px] sm:text-xs" : "px-7 py-3.5 text-sm"} ${className}`}
    >
      <span className="btn-sun-fill" aria-hidden="true" />
      <span className="btn-sun-sheen" aria-hidden="true" />
      <span className="relative z-10 flex items-center justify-center gap-2 whitespace-nowrap">{children}</span>
    </button>
  );
};

export const Arrow = ({ className = "" }) => (
  <ArrowRight className={`w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 ${className}`} />
);

export const OutlineButton = ({ children, onClick, testid, className = "" }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`btn-outline group inline-flex items-center justify-center gap-3 font-mono text-xs tracking-[0.16em] rounded-full px-7 py-3.5 ${className}`}
  >
    {children}
    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
  </button>
);
